module.exports = __webpack_public_path__ + "static/media/eyeLookInLeft.628748cb.obj";